import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import Seo from '../../components/Seo';

const SupportPage = () => {
    const { t, i18n } = useTranslation();

    return (
        <Fragment>
            <Seo title={`${t('support.landing.heroTitle')} | Orbitronix`} />
            <Layout>
                <main className="page_content pt-150 pb-120">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <div className="sec-title--two mb-60">
                                    <h2 className="title text-white">{t('support.landing.heroTitle')}</h2>
                                    <p className="text-white-50 mt-3">{t('support.landing.heroText')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-none-30 justify-content-center">
                            <div className="col-lg-4 col-md-6 mt-30">
                                <div className="p-5 rounded-4 h-100" style={{ background: '#080c27', border: '1px solid rgba(255,255,255,0.03)' }}>
                                    <div className="mb-4 d-flex align-items-center justify-content-center rounded-circle mx-auto" style={{ width: '70px', height: '70px', background: 'rgba(108, 92, 231, 0.1)', color: '#6c5ce7', fontSize: '30px' }}>
                                        <i className="fas fa-ticket-alt"></i>
                                    </div>
                                    <h4 className="text-white text-center mb-3">{t('support.landing.ticketsTitle')}</h4>
                                    <p className="text-white-50 text-center mb-4">{t('support.landing.ticketsDesc')}</p>
                                    <div className="text-center">
                                        <Link to="/support" className="btn btn-outline-primary rounded-pill px-4">{t('support.landing.myTickets')}</Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 mt-30">
                                <div className="p-5 rounded-4 h-100" style={{ background: '#080c27', border: '1px solid rgba(255,255,255,0.03)' }}>
                                    <div className="mb-4 d-flex align-items-center justify-content-center rounded-circle mx-auto" style={{ width: '70px', height: '70px', background: 'rgba(32, 201, 151, 0.1)', color: '#20c997', fontSize: '30px' }}>
                                        <i className="fas fa-envelope"></i>
                                    </div>
                                    <h4 className="text-white text-center mb-3">{t('support.landing.emailTitle')}</h4>
                                    <p className="text-white-50 text-center mb-4">{t('support.landing.emailDesc')}</p>
                                    <div className="text-center">
                                        <a href="mailto:OrbitroniX@gmail.com" className="btn btn-outline-success rounded-pill px-4">{t('support.landing.contactUs')}</a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 mt-30">
                                <div className="p-5 rounded-4 h-100" style={{ background: '#080c27', border: '1px solid rgba(255,255,255,0.03)' }}>
                                    <div className="mb-4 d-flex align-items-center justify-content-center rounded-circle mx-auto" style={{ width: '70px', height: '70px', background: 'rgba(0, 168, 255, 0.1)', color: '#00a8ff', fontSize: '30px' }}>
                                        <i className="fas fa-question"></i>
                                    </div>
                                    <h4 className="text-white text-center mb-3">{t('support.landing.faqTitle')}</h4>
                                    <p className="text-white-50 text-center mb-4">{t('support.landing.faqDesc')}</p>
                                    <div className="text-center">
                                        <Link to={`/${i18n.language}/about`} className="btn btn-outline-info rounded-pill px-4">{t('support.landing.learnMore')}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </Layout>
        </Fragment>
    );
};

export default SupportPage;